import { DomainError } from './domain.error';

export class InvalidEmailError extends DomainError {
  constructor(email: string) {
    super(`El formato del correo electrónico es inválido: "${email}"`, 'INVALID_EMAIL');
  }
}
